import type { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuCategoryPartnerIndexQuerySchema } from '~/services/api/generated'

// Mirrors MenuCategoryListRequest rules.
export const MenuCategoryPartnerIndex = (
  _context: NoContext
): z.ZodType<z.output<typeof MenuCategoryPartnerIndexQuerySchema>> =>
  MenuCategoryPartnerIndexQuerySchema
